export default __webpack_public_path__ + "static/media/product-house.445dc167.svg";